<template>
    <transition name="slide-up">
        <div v-if="showConsentBanner"
            class="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-primary shadow-2xl z-[9998]">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <!-- Cookie Message -->
                    <div class="flex-1">
                        <h3 class="text-lg font-header font-bold text-primary mb-2">
                            We Value Your Privacy
                        </h3>
                        <p class="text-sm font-body text-gray-700">
                            We use cookies to enhance your browsing experience. Essential cookies are required for the
                            shopping cart and site functionality.
                            You can choose to accept all cookies or use only essential cookies.
                            <a href="/cookies" class="text-accent hover:underline font-semibold">Learn more</a>
                        </p>
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                        <button @click="handleAcceptEssential"
                            class="px-6 py-3 font-body font-semibold text-primary bg-creme-200 hover:bg-creme-300 rounded-md transition-colors whitespace-nowrap">
                            Essential Only
                        </button>
                        <button @click="handleAcceptAll"
                            class="px-6 py-3 font-body font-semibold text-white bg-accent hover:bg-green-600 rounded-md transition-colors whitespace-nowrap">
                            Accept All
                        </button>
                    </div>
                </div>

                <!-- Settings Link -->
                <div class="mt-4 pt-4 border-t border-gray-200">
                    <p class="text-xs font-body text-gray-600">
                        You can change your cookie preferences at any time in your
                        <a href="/settings" class="text-accent hover:underline font-semibold">account settings</a>.
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { useCookieConsent } from '../composables/useCookieConsent'

const { showConsentBanner, acceptAll, acceptEssential } = useCookieConsent()

function handleAcceptAll() {
    acceptAll()
}

function handleAcceptEssential() {
    acceptEssential()
}
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.slide-up-enter-from {
    transform: translateY(100%);
    opacity: 0;
}

.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
</style>
